import { useEffect, useState } from "react";
import api from "../lib/api";

export default function Statistiche() {
  const [days, setDays] = useState(30);
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get(`/stats/overview?days=${days}`).then((r) => setStats(r.data)).catch(() => {});
  }, [days]);

  const cards = stats ? [
    ["Prenotazioni", stats.prenotazioni, "st-prenotazioni"],
    ["Coperti", stats.coperti, "st-coperti"],
    ["Cancellazioni", stats.cancellazioni, "st-cancellazioni"],
    ["No-show", stats.no_show, "st-noshow"],
    ["Clienti nuovi", stats.clienti_nuovi, "st-clienti-nuovi"],
    ["Clienti totali", stats.clienti_totali, "st-clienti-totali"],
    ["Coupon scaricati", stats.coupon_scaricati, "st-coupon-scaricati"],
    ["Coupon utilizzati", stats.coupon_utilizzati, "st-coupon-utilizzati"],
    ["Sondaggi compilati", stats.sondaggi_compilati, "st-sondaggi"],
    ["Valutazione media", stats.valutazione_media ?? "—", "st-valutazione"],
    ["Automazioni eseguite", stats.automazioni_eseguite, "st-automazioni"],
  ] : [];

  const maxCoperti = stats ? Math.max(...stats.per_giorno.map((d) => d.coperti), 1) : 1;

  return (
    <div className="space-y-5" data-testid="statistiche-page">
      <div className="flex items-center justify-between">
        <h1 className="font-display text-2xl sm:text-3xl font-bold tracking-tight text-zinc-900">Statistiche</h1>
        <div className="flex gap-1.5">
          {[7, 30, 90].map((d) => (
            <button key={d} onClick={() => setDays(d)} data-testid={`range-${d}`}
              className={`h-9 px-3 rounded-full text-xs font-semibold border ${days === d ? "bg-zinc-900 text-white border-zinc-900" : "bg-white text-zinc-600 border-zinc-200"}`}>
              {d}gg
            </button>
          ))}
        </div>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3">
        {cards.map(([label, value, testid]) => (
          <div key={label} className="bg-white border border-zinc-200 rounded-lg p-4" data-testid={testid}>
            <div className="text-[10px] uppercase tracking-wider font-semibold text-zinc-500">{label}</div>
            <div className="font-display text-3xl font-black tracking-tighter text-zinc-900 mt-1">{value}</div>
          </div>
        ))}
      </div>

      {stats && stats.per_giorno.length > 0 && (
        <section className="bg-white border border-zinc-200 rounded-lg p-4">
          <h2 className="font-display font-semibold text-zinc-900 mb-3">Coperti per giorno</h2>
          <div className="flex items-end gap-1 h-32" data-testid="chart-coperti">
            {stats.per_giorno.map((d) => (
              <div key={d.date} className="flex-1 flex flex-col items-center gap-1 min-w-0">
                <div className="w-full bg-zinc-900 rounded-t-sm transition-all" title={`${d.date}: ${d.coperti} coperti`}
                  style={{ height: `${(d.coperti / maxCoperti) * 100}%` }} />
                <span className="text-[9px] text-zinc-400 truncate w-full text-center">{d.date.slice(5)}</span>
              </div>
            ))}
          </div>
        </section>
      )}

      {stats && stats.campagne.length > 0 && (
        <section className="bg-white border border-zinc-200 rounded-lg">
          <h2 className="px-4 py-3 border-b border-zinc-200 font-display font-semibold text-zinc-900">Performance campagne</h2>
          <div className="divide-y divide-zinc-100">
            {stats.campagne.map((c) => (
              <div key={c.name} className="px-4 py-3 flex items-center gap-3 text-sm">
                <span className="font-semibold text-zinc-900 flex-1">{c.name}</span>
                <span className="text-xs text-zinc-500 capitalize">{c.type}</span>
                <span className="text-xs text-zinc-500">{c.stats?.sent ?? 0} inviati · {c.stats?.opened ?? 0} aperti</span>
              </div>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
